import AIAssistant from '@features/AIAssistant';
import { useTranslation } from '@hooks';
import { AI_TASK_TYPE, AITaskType } from '@constants/ai-assistant';
import { MENU_AI_DESCRIPTION_LIMIT } from '@constants/menus';

// Pulse AI toolbar for a menu description input: the standard text actions plus a
// context-aware "Write description" that keeps menu copy short.
const DescriptionAssistant = ({ value, setValue, context, language, disabled, setLoading }) => {
    const { t } = useTranslation();

    return (
        <AIAssistant
            btnStyles={{ position: 'absolute', left: 12, bottom: 32.5 }}
            value={value}
            setValue={setValue}
            disabled={disabled}
            setLoading={setLoading}
            additionalOptions={[
                {
                    text: t('AIAssistant.writeDescription'),
                    type: AITaskType.GenerateMenuDescription,
                    taskType: AI_TASK_TYPE.CONTEXTUAL,
                    customInstructions: context,
                    language,
                    maxCharacterLimit: MENU_AI_DESCRIPTION_LIMIT,
                },
            ]}
        />
    );
};

export default DescriptionAssistant;
